(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminServiceProviderFeedbackDisplayController', AdminServiceProviderFeedbackDisplayController);

    function AdminServiceProviderFeedbackDisplayController(
        $controller,
        lodash,
        settingsCollection,
        siteAssociateTypesCollection,
        $translate,
        recurrenceRulesService,
        assetScoreTypesCollection,
        contractManager,
        elbSettings,
        $state,
        module,
        modulesService,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'sp_feedback_active',
                'sp_feedback_modal_title',
                'sp_feedback_modal_body',
                'sp_feedback_display_job_statistics',
                'sp_feedback_allow_comments',
                'sp_feedback_allowed_popups_per_week'
            ],
            siteAssociateTypesCollection: siteAssociateTypesCollection,
            $translate: $translate,
            recurrenceRulesService: recurrenceRulesService,
            assetScoreTypesCollection: assetScoreTypesCollection,
            contractManager: contractManager,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService,
            fileTypeService: fileTypeService
        });

        angular.extend(vm, base);
    }
})();
